<script lang="ts" setup>
import { Co2QuizResults } from '@/models/co2-quiz.model';
import { ShiftCMSState } from '@/store';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { Co2QuizStoreState } from '@/stores/co2-quiz.store';

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const results = computed<Co2QuizResults[]>(() => store.state.co2.results);

const total = computed<number>(() =>
  results.value.reduce((acc: number, v) => (acc += v.co2value), 0),
);

const headers = [
  { title: 'Category', key: 'title', sortable: false },
  { title: 'kg CO₂', key: 'co2value', sortable: false },
];
</script>
<template>
  <v-container>
    <h2>Results</h2>

    <v-container>
      <div v-if="results.length">
        <p>
          Total: <strong>{{ total }}</strong
          ><span class="small">kg CO₂</span>
        </p>

        <v-data-table
          :items="
            [...results]
              .sort((a, b) => b.co2value - a.co2value)
              .filter((v) => v.co2value)
          "
          :headers="headers"
        >
          <template v-slot:item.co2value="{ value }">
            <strong>{{ parseFloat(value).toFixed(2) }}</strong>
          </template>
        </v-data-table>
      </div>
      <p v-else>There are no results, as no answers have been selected</p>
    </v-container>
  </v-container>
</template>
<style>
.small {
  font-size: 0.8em;
  padding: 0 2px;
}
</style>
